import { FullPageLoading } from '~/components/ui/loading'

export default FullPageLoading
